import React, { useContext } from "react";
import { InfoContext, Match } from "./InfoContext";

type MatchDayProps = {
  week: number;
  matches: Match[];
};

const formatDate = (dateString: string | null) => {
  if (!dateString) return "TBD";

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "TBD";

  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear().toString().slice(-2);

  return `${day}/${month}/${year}`;
};

const MatchDay: React.FC<MatchDayProps> = ({ week, matches }) => {
  const { getTeamById } = useContext(InfoContext);

  return (
    <div
      key={week}
      className="mb-8 p-4 bg-[#241f48] text-white rounded-lg mx-4 md:mx-auto max-w-4xl md:w-3/4 lg:w-2/3"
    >
      <h2 className="text-xl font-semibold mb-2">Week {week}</h2>
      <table className="border-collapse table-auto w-full rounded-lg overflow-hidden text-white">
        <thead>
          <tr className="bg-[#241f48] border-b-2">
            <th className="px-4 py-2 text-white text-">Home</th>
            <th className="px-4 py-2 text-white">Score</th>
            <th className="px-4 py-2 text-white">Guest</th>
            <th className="px-4 py-2 text-white text-right">Date</th>
          </tr>
        </thead>
        <tbody>
          {matches
            .sort(
              (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()
            )
            .map((match) => (
              <tr key={match.id} className="">
                <td className="py-2 px-4 text-right flex items-center justify-end text-white bg-transparent">
                  <span className="hidden sm:block">
                    {getTeamById(match.home_id)?.name || "UNK"}
                  </span>
                  <span className="block sm:hidden">
                    {getTeamById(match.home_id)?.name_short || "UNK"}
                  </span>
                  <img
                    src={
                      getTeamById(match.home_id)?.logo_url || "placeholder.png"
                    }
                    alt="Home Team Logo"
                    className="w-6 h-6 ml-2"
                  />
                </td>
                <td className="py-2 px-4 text-center text-white bg-transparent">
                  {match.results.some((res) => res.is_final)
                    ? `${
                        match.results.find((res) => res.is_final)?.score_home
                      } - ${
                        match.results.find((res) => res.is_final)?.score_guest
                      }`
                    : "-"}
                </td>
                <td className="py-2 px-4 text-left flex items-center justify-start text-white bg-transparent">
                  <img
                    src={
                      getTeamById(match.guest_id)?.logo_url || "placeholder.png"
                    }
                    alt="Guest Team Logo"
                    className="w-6 h-6 mr-2"
                  />
                  <span className="hidden sm:block">
                    {getTeamById(match.guest_id)?.name || "UNK"}
                  </span>
                  <span className="block sm:hidden">
                    {getTeamById(match.guest_id)?.name_short || "UNK"}
                  </span>
                </td>
                <td className="py-2 px-4 text-right text-white bg-transparent">
                  {formatDate(match.date)}
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};
export default MatchDay;
